import Service, { inject as service } from '@ember/service';

export default class BrandCommands extends Service {
  @service api;
  @service shData;
  @service store;

  /**
   *
   * @param companyId
   * @returns {*}
   */
  loadBrandsForCompany(companyId, includes = null) {
    const options = {};

    if (includes) {
      options.params = {
        include: includes.join(','),
      }
    }

    return this.api.request(`companies/${companyId}/brands`, options).then(response => {
      this.shData.pushResponseToStore(response);
      return this.shData.getModelArrayFromResponse(response, 'brand');
    });
  }

  /**
   *
   * @param brandId
   * @returns {*}
   */
  loadBrandById(brandId, includes = null) {
    const options = {};

    if (includes) {
      options.params = {
        include: includes.join(','),
      }
    }

    return this.api.request(`/brands/${brandId}`, options).then(response => {
      this.shData.pushResponseToStore(response);
      return this.store.peekRecord('brand', response.data.id);
    });
  }

  /**
   *
   * @param companyId
   * @param name
   * @param is_third_party
   * @returns {*}
   */
  storeBrand(companyId, name, is_third_party) {
    const options = {
      params: {
        include: 'image',
      },
      jsonData: {
        name,
        is_third_party,
      }
    };

    return this.api.post(`companies/${companyId}/brands`, options).then(response => {
      this.shData.pushResponseToStore(response);
      return this.store.peekRecord('brand', response.data.id);
    });
  }

  /**
   *
   * @param brandId
   * @param name
   * @param is_third_party
   * @returns {*}
   */
  updateBrand(brandId, name, is_third_party) {
    const options = {
      params: {
        include: 'image',
      },
      jsonData: {
        name,
        is_third_party,
      }
    };

    return this.api.put(`brands/${brandId}`, options).then(response => {
      this.shData.pushResponseToStore(response);
      return this.store.peekRecord('brand', response.data.id);
    });
  }
  
  /**
   *
   * @param brandId
   * @returns {*}
   */
  destroyBrand(brandId) {
    return this.api.delete(`brands/${brandId}`);
  }

  /**
   *
   * @param brandId
   * @param companyTeamId
   * @returns {*}
   */
  storeBrandCompanyTeam(brandId, companyTeamId) {
    return this.api.post(`company-teams/${companyTeamId}/setBrand/${brandId}`);
  }

  /**
   *
   * @param brandId
   * @param companyTeamId
   * @returns {*}
   */
  destroyBrandCompanyTeam(brandId, companyTeamId) {
    return this.api.delete(`company-teams/${companyTeamId}/removeBrand/${brandId}`);
  }
}
